import {
  CircularProgress,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SettingsPageText } from "../../data/texts";
import { Images } from "../../models/assets-files";
import { ImageService } from "../../services/image.service";
import { UserService } from "../../services/user.service";
import { StoreState } from "../../store/store";
import { StyledSettingsScreen } from "../../styled-cmps/settings-screen";
import Image from "../common/Image";
import useScreen from "../common/UseScreen";

const ProfileScreen = () => {
  const { isDesktop } = useScreen();
  const theme = useTheme();
  const user = useSelector((state: StoreState) => state.user.loggedInUser);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    fullName: user?.fullName,
    email: user?.email,
    phone: "",
    otherPhone: "",
  });

  useEffect(() => {
    fetchPhoneNumbers();
  }, []);

  const fetchPhoneNumbers = async () => {
    const fetchedPhoneNumbers = await UserService.getUserPhoneNumbers();
    if (fetchedPhoneNumbers) {
      setFormData({
        ...formData,
        phone: fetchedPhoneNumbers.Phone,
        otherPhone: fetchedPhoneNumbers.Other_Phone,
      });
    }
    setIsLoading(false);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const imageBreakpointXL = useMediaQuery("(min-width: 1190px)");
  const imageBreakpointLG = useMediaQuery("(min-width: 1000px)");
  return (
    <StyledSettingsScreen
      sx={{
        ...(isLoading ? theme.customStyles.disabled : ""),
        position: "relative",
      }}
      alignItems={isDesktop ? "flex-start" : "center"}
      flexDirection={isDesktop ? "row" : "column-reverse"}
    >
      {isLoading && (
        <CircularProgress
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
      <Stack
        gap={"10px"}
        sx={{
          width: isDesktop ? "40%" : "100%",
          minWidth: "300px",
        }}
      >
        <Typography sx={{ fontWeight: "400" }}>
          {SettingsPageText.PROFILE}
        </Typography>
        <Typography>{SettingsPageText.YOUR_INFO}</Typography>
        <TextField
          slotProps={{ input: { readOnly: true } }}
          value={formData.fullName}
          name="fullName"
          onChange={handleChange}
          label={SettingsPageText.FULL_NAME}
        />
        <TextField
          slotProps={{ input: { readOnly: true } }}
          value={formData.email}
          name="email"
          onChange={handleChange}
          label={SettingsPageText.EMAIL}
        />
        <TextField
          slotProps={{ input: { readOnly: true } }}
          value={formData.phone}
          name="phone"
          onChange={handleChange}
          label={SettingsPageText.PHONE}
        />
        <TextField
          slotProps={{ input: { readOnly: true } }}
          value={formData.otherPhone}
          name="otherPhone"
          onChange={handleChange}
          label={SettingsPageText.OTHER_PHONE}
        />
      </Stack>
      <Image
        sx={{
          width: imageBreakpointXL
            ? "400px"
            : imageBreakpointLG
            ? "300px"
            : "230px",
          objectFit: "contain",
        }}
        src={ImageService.getLocalImgPath(
          Images.Folders.SETTINGS,
          Images.Settings.USER_LAPTOP,
          "png"
        )}
      />
    </StyledSettingsScreen>
  );
};

export default ProfileScreen;
